import http from "infra/http";
import { useQuery } from "react-query";
import { IndexadorItem } from "../typings";

function useGetFracoes() {
  return useQuery([`/v1/indexador`], async () => {
    const { data } = await http.get(`/v1/indexador`);
    return data as IndexadorItem[];
  });
}

export default useGetFracoes;
